// import Index from '../../views/Index.vue'
import Manage from '../../views/Manage.vue'
import Pano from '../../views/Pano.vue'
import Media from '../../views/Media.vue'
import Product from '../../views/Product.vue'
import Account from '../../views/Account.vue'
import upload from '../../components/upload.vue'
//import mediaPano from '../../views/media/pano.vue'


export default [{
  path: '/my',
  redirect: '/my/manage'
},
{
  path: '/my/manage',
  name: '管理首页',
  component: Manage
}, {
  path: '/my/pano',
  name: '发布',
  component: Pano
}, {
  path: '/my/product',
  name: '作品管理',
  component: Product
}, {
  path: '/my/media',
  name: '素材库',
  component: Media
  // children: [{
  //   path: 'pano',
  //   name: '全景图片',
  //   component: mediaPano,

  // }]
}, {
  path: '/my/account',
  name: '作品管理',
  component: Account
},
{
  path: '/my/upload',
  name: '上传',
  component: upload
}

]
